var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('smd-chat-status',_vm._b({staticClass:"chat-item-doctor",class:{'smd-panel': !_vm.$isMobile},nativeOn:{"click":function($event){return _vm.onItemClick.apply(null, arguments)}}},'smd-chat-status',_vm.chatStatusBindValues,false))}
var staticRenderFns = []

export { render, staticRenderFns }